// extracted by mini-css-extract-plugin
export default {"scroll-chat-main":"ScrollChat_scroll-chat-main__4MZsM","single-chat":"ScrollChat_single-chat__04hCa","user":"ScrollChat_user__oEVST","gemini":"ScrollChat_gemini__Z5v4H"};